import { render, staticRenderFns } from "./AgentsCommissions.vue?vue&type=template&id=7bef82d3&"
import script from "./AgentsCommissions.vue?vue&type=script&lang=js&"
export * from "./AgentsCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports